import { Module } from 'vuex';
import { RootState, ListStatus, EditableStatus } from '@/store/types';
import { DistributorsState } from '@/store/modules/distributors/types';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const getInitialState = (): DistributorsState => ({
  list: [],
  listStatus: ListStatus.Loading,
  editableStatus: EditableStatus.Loading,
  currentDistributor: undefined,
  editableDistributor: undefined,
});

export const state: DistributorsState = getInitialState();

const distributors: Module<DistributorsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default distributors;
